'use strict';

module.exports = strikethrough;

var all = require('../all');

/* Transform deletions. */
function strikethrough(h, node) {
  return h(node, 'del', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/delete.js
// module id = 218
// module chunks = 96961042003272 139266963665775